export default function Products() {
  return (
    <section id="products" className="py-20 px-20 bg-[#121212] max-w-[1440px] mx-auto">
      <div className="text-center mb-24">
        <p className="text-xs uppercase tracking-[2px] font-light text-[#C9A961] mb-4">
          OUR PRODUCTS
        </p>
        <h2 className="text-[56px] leading-tight font-serif text-white">
          VPN & Cleaner
        </h2>
        <h3 className="text-[52px] leading-tight font-serif italic text-white/90">
          Applications
        </h3>
      </div>
      
      <div className="grid grid-cols-2 gap-16" data-product-shop>
        <div className="h-[520px] rounded-[28px] bg-[#0D1B2A] p-12 relative overflow-hidden group hover:scale-[1.02] transition-transform duration-300 cursor-pointer">
          <div className="absolute top-12 left-12 w-20 h-20 rounded-full bg-gradient-to-br from-[#3B82F6] to-[#1E40AF] flex items-center justify-center">
            <i className="ri-shield-check-line text-white text-3xl"></i>
          </div>
          
          <div className="mt-32">
            <h4 className="text-[64px] font-bold text-white mb-4">VPN</h4>
            <p className="text-xl font-light text-[#7A8B99]">
              Enhanced Security & Privacy
            </p>
          </div>
          
          <div className="absolute bottom-0 left-0 right-0 h-48">
            <img 
              src="https://public.readdy.ai/ai/img_res/359551fe31a0289b5745ff0ec02e2662.jpg"
              alt="VPN Network Visualization"
              className="w-full h-full object-cover opacity-60"
            />
          </div>
        </div>
        
        <div className="h-[520px] rounded-[28px] bg-[#1C1C1E] p-12 relative overflow-hidden group hover:scale-[1.02] transition-transform duration-300 cursor-pointer">
          <div className="absolute top-12 left-12 w-20 h-20 rounded-full bg-gradient-to-br from-[#10B981] to-[#059669] flex items-center justify-center">
            <i className="ri-brush-line text-white text-3xl"></i>
          </div>
          
          <div className="mt-32">
            <h4 className="text-[64px] font-bold text-white mb-4">Cleaner</h4>
            <p className="text-xl font-light text-[#8E8E93]">
              Device Optimization Tools
            </p>
          </div>
          
          <div className="absolute bottom-0 left-0 right-0 h-48">
            <img 
              src="https://readdy.ai/api/search-image?query=minimalist%20graphic%20showing%20storage%20optimization%20concept%20with%20clean%20geometric%20shapes%2C%20device%20performance%20visualization%20in%20warm%20gray%20tones%2C%20abstract%20representation%20of%20file%20cleaning%20and%20memory%20management%2C%20modern%20tech%20illustration%2C%20simple%20elegant%20design%20on%20dark%20background&width=600&height=300&seq=cleaner-visual-001&orientation=landscape"
              alt="Cleaner Optimization Visualization"
              className="w-full h-full object-cover opacity-60"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
